var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("app-pay-row", { attrs: { label: _vm.$ct("labels.total") } }, [
        _vm._v(" € " + _vm._s(_vm._f("printHumanFloat")(_vm.price)) + " "),
      ]),
      _vm.discount != 0
        ? _c(
            "app-pay-row",
            {
              attrs: {
                label: _vm.$ct("discount") + " (-" + _vm.prettyDiscount + "%)",
              },
            },
            [
              _vm._v(
                " - € " +
                  _vm._s(_vm._f("printHumanFloat")(_vm.pricing.discount)) +
                  " "
              ),
            ]
          )
        : _vm._e(),
      _vm.hasVat
        ? [
            _c(
              "app-pay-row",
              {
                style: { fontWeight: "bold" },
                attrs: { label: _vm.$ct("price-with-vat") },
              },
              [
                _vm._v(
                  " € " +
                    _vm._s(_vm._f("printHumanFloat")(_vm.priceWithVat)) +
                    " "
                ),
              ]
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }